import React from "react";

function BlogButton() {




    return(
        <></>
        // <div className="w-11/12 bg-[#e6f9fc] border-2 border-black h-12 rounded-lg">
        //     {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores molestias quam enim ducimus voluptate ex blanditiis minus rerum molestiae quis, totam repellendus sapiente quas fugit beatae cum repudiandae perspiciatis porro.</p> */}
        // </div>
    );
}

export default BlogButton;